// Navigation utility for use outside Router context
let navigateFunction = null;

export const setNavigateFunction = navigate => {
  navigateFunction = navigate;
};

export const navigateTo = path => {
  if (navigateFunction) {
    navigateFunction(path);
  } else {
    // Fallback to window.location.href if navigate function is not available
    window.location.href = path;
  }
};

export default {
  setNavigateFunction,
  navigateTo
};
